module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm1_m_en.99c6075e2f6e680fb20903f6feb57c0c.png";